<li inline-flex [routerLink]="link" class="mb-2 py-1 cursor-pointer px-4 text-purple w-full rounded-2xl"
  [routerLinkActive]="'colors-primary-bg'">
  <ng-content select="[iconTag]"></ng-content>
  <ng-content></ng-content>
</li>
